import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";

@Injectable()
export class EmpleadoService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        })
    };
    private dataUser = JSON.parse(localStorage.getItem('USER_CURRENT'));
    private uuid = this.dataUser.uuidCompany;
    private currentUser = this.dataUser.name;

    constructor(
        private http: HttpClient
    ) {
    }

    createEmployee(data: any): Observable<any> {
        let url = `${environment.api.adminApis}${this.uuid}/employees`;
        return this.http.post(url, data, this.httpOptions);
    }

    getEmployee() {
        let shareGet;
        let url = `${environment.api.adminApis}${this.uuid}/employees`;
        shareGet = this.http.get(url);
        return shareGet;
    }

    getEmployeeUUID(uuid) {
        let shareGet;
        let url = `${environment.api.adminApis}${this.uuid}/employees/${uuid}`;
        shareGet = this.http.get(url);
        return shareGet;
    }

    getDocumentsEmployees(uuid) {
        let shareGet;
        let url = `${environment.api.adminApis}employees/documents/${uuid}`;
        shareGet = this.http.get(url);
        return shareGet;
    }

    updateEmployee(data, register): Observable<any> {
        let url = `${environment.api.adminApis}${this.uuid}/employees/${register}`;
        return this.http.put(url, data);
    }

    deleteEmployee(uuid, companyUUID?): Observable<any> {
        const companyUuid = companyUUID || this.uuid;
        let url = `${environment.api.adminApis}${companyUuid}/employees/${uuid}?currentUser=${this.currentUser}`;
        return this.http.delete(url);
    }

    deleteEmployeeDelete(uuid, companyUUID?): Observable<any> {
        const companyUuid = companyUUID || this.uuid;
        let url = `${environment.api.adminApis}${companyUuid}/employees-delete/${uuid}?currentUser=${this.currentUser}`;
        return this.http.delete(url);
    }

    reactivateEmployee(uuid, companyUUID?): Observable<any> {
        const companyUuid = companyUUID || this.uuid;
        let url = `${environment.api.adminApis}${companyUuid}/employees-reactivate/${uuid}?currentUser=${this.currentUser}`;
        return this.http.delete(url);
    }

    generateDocumentEmployee(data: any, uuid_Document, uuid_employee): Observable<any> {
        let url: string = `${environment.api.dataApis}/template/documents/${uuid_Document}/employees/${uuid_employee}/generate_document`;
        return this.http.post(url, data, {
            responseType: 'arraybuffer', 
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/octet-stream'
            })
        });
    }

    exportDocumentEmployee(data: any): Observable<any> {
        let url: string = `${environment.api.adminApis}documents/download`;
        return this.http.post(url, data, {
            responseType: 'arraybuffer', 
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/octet-stream'
            })
        });
    }

    exportFileConfig(uuid) {
        let url = `${environment.api.templateApis}${uuid}/documents`;
        let pwa = window.open(url);
        if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
            alert('Desactive el bloqueador de elementos emergentes y vuelva a intentarlo.');
        }
    }

    getEmployeeActas(uuid_employee: string): Observable<any> {
        let url = `${environment.api.dataApis}/actas-administrativas/employee/${uuid_employee}`;
        return this.http.get(url, this.httpOptions);
    }

    generateActaAdministrativa(data: any, uuid_employee: string): Observable<any> {
        let url = `${environment.api.dataApis}/actas-administrativas/generate/${uuid_employee}`;
        return this.http.post(url, data, {
            responseType: 'arraybuffer', 
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/octet-stream'
            })
        });
    }

    getActa(uuid_acta: string): Observable<any> {
        let url = `${environment.api.dataApis}/actas-administrativas/acta/${uuid_acta}`;
        return this.http.get(url, {
            responseType: 'arraybuffer', 
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/octet-stream'
            })
        });
    }

    getEmployeeDetail(uuid_employee: string): Observable<any> {
        let url = `${environment.api.dataApis}/analytics/employee-detail/${uuid_employee}`;
        return this.http.get(url, this.httpOptions);
    }
}
